module.exports = __webpack_public_path__ + "static/media/btc.e73cb1b2.svg";